import * as React from "react";
import { BlogPost as BlogPostProps } from "../../../../stores/BlogStore/Types";

interface Props {
  post: BlogPostProps;
  idx: number;
}

const BlogPost: React.FC<Props> = ({ post, idx }) => {
  const date = new Date(post.pubDate).toDateString();
  const dateElements = date.split(" ");
  dateElements.shift();
  const formattedDate = dateElements.join(" ");
  const tag = idx % 2 === 0 ? "Ideas" : "Learning";

  return (
    <a className="blog-card" href={post?.link}>
      <div className="thumb">
        <img
          src={post?.content?.url}
          alt={post?.content?.title}
          loading="lazy"
          decoding="async"
        />
      </div>
      <div className="body">
        <span className="post-tag">{tag}</span>
        <h3 className="header">{post?.title}</h3>
        <div className="date">{formattedDate}</div>
        <div
          className="excerpt description"
          dangerouslySetInnerHTML={{ __html: post?.description }}
        ></div>
        <span className="read-more">Read more</span>
      </div>
    </a>
  );
};

export default BlogPost;
